var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCrown = function SvgIconCrown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    strokeWidth: 0
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m64 31.485 28.902 36.128 28.903-36.128-7.226 65.03H13.421l-7.226-65.03 28.903 36.128L64 31.485z"
  })));
};
export { SvgIconCrown as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMjggMTI4IiBzdHJva2Utd2lkdGg9IjAiPgogICAgPHBhdGgKICAgICAgICBkPSJtIDY0LjAwMDAxMiwzMS40ODQ5NDQgMjguOTAyMzQ2LDM2LjEyNzg3MSAyOC45MDIyNDIsLTM2LjEyNzg3MSAtNy4yMjU1Myw2NS4wMzAxNDcgLTEwMS4xNTgwODYsCiAgICAgICAgICAgIDAgTCA2LjE5NTQyMzcsMzEuNDg0OTQ0IDM1LjA5NzcsNjcuNjEyODE1IDY0LjAwMDAxMiwzMS40ODQ5NDQgeiIKICAgIC8+Cjwvc3ZnPgo=";